import ElementController from "../base-controllers/ElementController.js";
import { removeStaticAttr, setStaticAttr } from "../utils/morph/helpers.js";
/** Present an organization logo file input as preview, change and remove actions. */
class OrganizationLogoInput extends ElementController {
    constructor() {
        super(...arguments);
        this.chooseLogo = () => this.input.click();
        this.selectLogo = () => {
            const file = this.input.files?.[0];
            if (!file)
                return;
            this.revokePreview();
            this.previewUrl = URL.createObjectURL(file);
            // Keep widget mutations backend-owned so an undo fragment can remove them.
            setStaticAttr(this.image, "src", this.previewUrl);
            removeStaticAttr(this.image, "hidden");
            setStaticAttr(this.placeholder, "hidden", "");
            this.fileName.textContent = file.name;
            this.chooseButton.textContent = this.root.dataset.changeLabel ?? "";
            removeStaticAttr(this.removeButton, "hidden");
            if (this.clearInput)
                this.clearInput.checked = false;
        };
        this.removeLogo = () => {
            this.revokePreview();
            this.input.value = "";
            if (this.clearInput)
                this.clearInput.checked = true;
            setStaticAttr(this.image, "hidden", "");
            removeStaticAttr(this.image, "src");
            removeStaticAttr(this.placeholder, "hidden");
            this.fileName.textContent = this.root.dataset.noLogoLabel ?? "";
            this.chooseButton.textContent = this.root.dataset.chooseLabel ?? "";
            setStaticAttr(this.removeButton, "hidden", "");
            this.input.dispatchEvent(new Event("change", { bubbles: true }));
        };
    }
    get input() {
        return this.root.querySelector("[data-logo-input]");
    }
    get clearInput() {
        return this.root.querySelector("[data-logo-clear]");
    }
    get image() {
        return this.root.querySelector("[data-logo-image]");
    }
    get placeholder() {
        return this.root.querySelector("[data-logo-placeholder]");
    }
    get fileName() {
        return this.root.querySelector("[data-logo-file-name]");
    }
    get chooseButton() {
        return this.root.querySelector("[data-logo-choose]");
    }
    get removeButton() {
        return this.root.querySelector("[data-logo-remove]");
    }
    destroy() {
        this.revokePreview();
    }
    revokePreview() {
        if (!this.previewUrl)
            return;
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = undefined;
    }
}
OrganizationLogoInput.id = "OrganizationLogoInput";
OrganizationLogoInput.binds = {
    "[data-logo-input]": [["change", "selectLogo"]],
    "[data-logo-choose]": [["click", "chooseLogo"]],
    "[data-logo-remove]": [["click", "removeLogo"]],
};
export default OrganizationLogoInput;
//# sourceMappingURL=OrganizationLogoInput.js.map